import { render } from "./SettingsTabPostback.vue?vue&type=template&id=4eacfa3d"
import script from "./SettingsTabPostback.vue?vue&type=script&lang=js"
export * from "./SettingsTabPostback.vue?vue&type=script&lang=js"

import "./SettingsTabPostback.vue?vue&type=style&index=0&id=4eacfa3d&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__